import React from "react";

function RNG() {
  let MAX = 256;
  let color = Math.floor(Math.random() * MAX);

  return color;
}

export default RNG;
